import useBodyClasses from "@/hooks/useBodyClasses";
import { toAbsoluteUrl } from "@/utils";
import { Fragment } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "@/services/AuthService";
import { logout } from "@/store/authSlice";
import { useDispatch } from "react-redux";
import { useState } from "react";

const Error401Page = () => {
  useBodyClasses("dark:bg-coal-500");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [logoutMutation] = useLogoutMutation();
  const [message] = useState(() => {
    const storedMessage = localStorage.getItem("message");
    localStorage.removeItem("message");
    return storedMessage;
  });

  const handleLogout = async () => {
    try {
      await logoutMutation().unwrap();
      dispatch(logout());
      navigate("/auth/login");
    } catch (error) {
      console.error("Logout failed:", error);
      navigate("/auth/login");
    }
  };

  return (
    <Fragment>
      <div className="mb-10">
        <img
          src={toAbsoluteUrl("/media/illustrations/19 1.svg")}
          className="dark:hidden max-h-[160px]"
          alt="image"
        />
        <img
          src={toAbsoluteUrl("/media/illustrations/19-dark 1.svg")}
          className="light:hidden max-h-[160px]"
          alt="image"
        />
      </div>

      <span className="badge badge-primary badge-outline mb-3">401 Error</span>

      <h3 className="text-xl md:text-2.5xl font-semibold text-gray-900 text-center mb-2 px-[20px] md:px-[0px]">
        {message || "Contact admin for assistance."}
      </h3>

      <div className="text-md text-center text-gray-700 mb-10">
        <button
          onClick={handleLogout}
          className="text-white font-medium btn btn-primary"
        >
          Login
        </button>
      </div>
    </Fragment>
  );
};

export { Error401Page };
